<template>
  <div>
    <sho></sho>
    <router-view/>
  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?ea82a2e454296a8409792bd117de4f5e";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
import sho from "./components/sho.vue";
export default {
  name: 'App',
  components: { sho },
  data () {
    return {
    }
  },
  created () {
  }

}
</script>

<style>
</style>
